import { render, staticRenderFns } from "./ListCompleted.vue?vue&type=template&id=423a0b3c&"
import script from "./ListCompleted.vue?vue&type=script&lang=js&"
export * from "./ListCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ListCompleted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports